namespace TabAurous.Common {
    export interface ShapeFilterForm {
        ShapeFilter1: Serenity.ServiceLookupEditor;
        ShapeFilter2: Serenity.ServiceLookupEditor;
    }

    export class ShapeFilterForm extends Serenity.PrefixedContext {
        static formKey = 'Common.ShapeFilter';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ShapeFilterForm.init)  {
                ShapeFilterForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;

                Q.initFormType(ShapeFilterForm, [
                    'ShapeFilter1', w0,
                    'ShapeFilter2', w0
                ]);
            }
        }
    }
}
